import { createRoute, Navigate } from '@tanstack/react-router';
import LoadingScreen from 'components/LoadingScreen';
import MainLayout from 'layouts/dashboard/MainLayout';
import { rootRoute } from 'routes/rootRoute';
import { canAccessPharmacyPages, WithEnsure } from 'routes/routeUtils';

export const pharmacyParentRoute = createRoute({
  getParentRoute: () => rootRoute,
  component: () => WithEnsure(canAccessPharmacyPages, <MainLayout />),
  path: '/pharmacy',
  pendingComponent: LoadingScreen,
});

export const pharmacyIndexRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/',
  component: () => <Navigate to="/pharmacy/trades" />,
});
